/*
 * AT.klaviyo — Klaviyo client API (ported from arlo-mott's src/utilities/klaviyo.js).
 *
 * Namespaced on window.AT.klaviyo. No build step; plain IIFE.
 * Client endpoints take the public API key (company id) as a query param, so no
 * secret is involved — the key comes from the theme setting `klaviyo_token`.
 *
 *   AT.klaviyo.submitWaitlist({ token: '…', email: '…', variantId: '123' })
 *     -> Promise, resolves on Klaviyo's 202, rejects with an Error on failure
 */
(function initAtKlaviyo() {
  window.AT = window.AT || {};
  if (window.AT.klaviyo) return;

  var BACK_IN_STOCK_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
  var REVISION = '2024-06-15';

  var submitWaitlist = function submitKlaviyoWaitlist(params) {
    var options = params || {};
    if (!options.token) return Promise.reject(new Error('Klaviyo public API key missing'));
    if (!options.email || !options.variantId) return Promise.reject(new Error('Email and variant required'));

    return fetch(BACK_IN_STOCK_ENDPOINT + '?company_id=' + encodeURIComponent(options.token), {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        revision: REVISION,
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: options.email } } },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: { type: 'catalog-variant', id: '$shopify:::$default:::' + options.variantId },
            },
          },
        },
      }),
    })
      .then(function (res) {
        // 202 comes back with an empty body; don't try to parse it.
        if (res.status === 202) return { status: res.status };
        return res.json();
      })
      .then(function (json) {
        if (json && json.errors && json.errors.length) {
          throw new Error(
            json.errors
              .map(function (err) {
                return err.title;
              })
              .join(' ')
          );
        }
        return json;
      });
  };

  window.AT.klaviyo = { submitWaitlist: submitWaitlist };
})();
